// functions/client/js/entrypoints/urlValidation.ts
import { isSafeRedirectUrl, getUrlVars } from '../common/urlValidation';

if (typeof window !== 'undefined') {
    (window as any).isSafeRedirectUrl = isSafeRedirectUrl;
    (window as any).getUrlVars = getUrlVars;
}

export { isSafeRedirectUrl, getUrlVars };
